import api from './http';

// Portail Coopérateur — Missions
export const portalListMissions = () => api.get('/portal/missions');

// Portail Coopérateur — Conventions
export const portalListConventions = (params = {}) => {
  const qs = new URLSearchParams();
  if (typeof params.archived === 'boolean') qs.append('archived', params.archived);
  return api.get(`/portal/conventions${qs.toString() ? `?${qs.toString()}` : ''}`);
};
export const portalGetConvention = (id) => api.get(`/portal/conventions/${id}`);
export const portalSignConvention = (id, data) => api.post(`/portal/conventions/${id}/sign`, data);
export const portalPreviewConvention = (id) => api.get(`/cmc/contracts/${id}/preview`, { responseType: 'blob' });
export const portalDownloadConvention = (id) => api.get(`/cmc/contracts/${id}/download`, { responseType: 'blob' });

// Portail — Paiement
export const portalPaymentCheckout = (data) => api.post('/portal/payment-checkout', data);

// Onboarding
export const getPortalOnboarding = () => api.get('/portal/onboarding');
export const getOnboardingOverview = () => api.get('/onboarding/overview');
export const getOnboardingNotifications = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.limit) qs.append('limit', params.limit);
  if (params.skip) qs.append('skip', params.skip);
  if (params.event_type) qs.append('event_type', params.event_type);
  if (params.status) qs.append('status', params.status);
  return api.get(`/onboarding/notifications?${qs.toString()}`);
};
export const getOnboardingNotifSettings = () => api.get('/onboarding/notifications/settings');
export const updateOnboardingNotifSettings = (data) => api.patch('/onboarding/notifications/settings', data);
export const testOnboardingNotifications = () => api.post('/onboarding/notifications/test');
export const getPortalOnboardingNotifications = (limit = 20) => api.get(`/portal/onboarding/notifications?limit=${limit}`);

// Client Portal Admin
export const getClientAccounts = () => api.get('/client/accounts');
export const createClientAccount = (data) => api.post('/client/accounts', data);
export const updateClientAccount = (id, data) => api.patch(`/client/accounts/${id}`, data);
export const getClientNotificationSettings = () => api.get('/client/notification-settings');
export const updateClientNotificationSettings = (data) => api.patch('/client/notification-settings', data);
export const getClientNotificationLogs = (limit = 30) => api.get(`/client/notification-logs?limit=${limit}`);
